import type React from 'react';
import { useActivityTracking } from './hooks/useActivityTracking';
import { useSessionInitialization } from './hooks/useSessionInitialization';
import { useSessionToken } from './hooks/useSessionToken';
import type { SessionManagerProps } from './SessionManager.types';

export const SessionManager: React.FC<SessionManagerProps> = () => {
  useSessionToken();

  useSessionInitialization();

  useActivityTracking();

  return null;
};
